(() => {
  if (customElements.get("bhj-gallery-controls")) return;
  customElements.define("bhj-gallery-controls", class extends HTMLElement {
    async connectedCallback() {
      const connection = new AbortController();
      this.connection?.abort();
      this.connection = connection;
      await customElements.whenDefined("scroll-carousel");
      if (!this.isConnected || connection.signal.aborted) return;
      const gallery = this.closest("product-gallery");
      const carousel = gallery?.querySelector(".product-gallery__carousel");
      const form = gallery && document.forms[gallery.getAttribute("form")];
      const previous = this.querySelector("[data-gallery-previous]");
      const next = this.querySelector("[data-gallery-next]");
      if (!carousel || !previous || !next) return;
      const sync = () => {
        const count = carousel.cells.length;
        previous.disabled = count < 2 || carousel.selectedIndex <= 0;
        next.disabled = count < 2 || carousel.selectedIndex >= count - 1;
      };
      previous.addEventListener("click", () => {
        carousel.previous();
        sync();
      }, { signal: connection.signal });
      next.addEventListener("click", () => {
        carousel.next();
        sync();
      }, { signal: connection.signal });
      for (const event of ["carousel:change", "carousel:settle", "carousel:filter"]) {
        carousel.addEventListener(event, sync, { signal: connection.signal });
      }
      form?.addEventListener("variant:change", () => {
        requestAnimationFrame(() => {
          if (connection.signal.aborted) return;
          carousel.select(0, { instant: true });
          sync();
        });
      }, { signal: connection.signal });
      sync();
    }
    disconnectedCallback() {
      this.connection?.abort();
    }
  });
})();
